import styled, { css } from 'styled-components'

import useWindowSize from '../../hooks/useWindowSize'
import theme, { rem } from '../../utils/theme'
import OrgUserDropdown from './OrgUserDropdown'

const StyledOrganisationHeader = styled.header`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: ${rem(theme.regoForm.pageHeaderHeightMobile)};
  background-color: ${theme.regoForm.pageHeaderBg};
  position: relative;
  z-index: 5;

  ${theme.breakpoints.up('xs')} {
    height: ${rem(theme.regoForm.pageHeaderHeightDesktop)};
  }

  > div {
    position: relative;
    z-index: 2;
  }
`

const StyledFormTitleContainer = styled.div`
  width: 70%;
  margin-top: ${rem(5)};
  overflow: hidden;
  position: relative;
  max-height: ${rem(60)};
  overflow: hidden;

  > h1 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    align-content: center;
    text-align: center;
  }
`

const StyledFormTitle = styled.h1`
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.fontSizeBase};
  font-weight: ${theme.typography.fontWeightBold};
  color: ${theme.regoForm.pageHeaderColor};
  z-index: 1;

  ${props =>
    props.isMobile &
    css`
    color: ${theme.colors.white}
    height: auto;
    margin: 30px 0 0 !important;
    position: relative;    
  `}
`

const StyledFormLogo = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 ${rem(8)};

  ${theme.breakpoints.up('sm')} {
    padding: 0 0 0 ${rem(14)};
  }

  > img {
    display: block;
    max-height: ${rem(44)};
  }
`

const StyledOrgUserInfo = styled.div`
  display: flex;
  align-items: center;
`

const OrganisationHeader = ({
  formTitle,
  formLogo,
  orgName,
  orgLogo,
  userName,
  isAuthenticated,
  logOutRequest,
  landingPageLink = '',
  portalLink,
  appVersion,
}) => {
  const { width: windowWidth } = useWindowSize()
  const isMobile = windowWidth < theme.breakpoints.values.md
  const isLongTitle = formTitle.length > 58
  if (landingPageLink && landingPageLink.length > 0) {
    if (process.env.NODE_ENV === 'development') {
      const subdomain = landingPageLink.split('//')[1].split('.')[0]
      landingPageLink = `http://localhost:3005/event/${subdomain}`
    }

    if (landingPageLink.includes('.events-test.mygameday.')) {
      const subdomain = landingPageLink.split('//')[1].split('.')[0]
      landingPageLink = `https://${subdomain}.event-testing.mygameday.app`
    }
  }
  return (
    // biome-ignore lint/complexity/noUselessFragments: TODO
    <>
      <StyledOrganisationHeader>
        {/** biome-ignore lint/complexity/noUselessFragments: TODO */}
        <>
          <StyledFormLogo>{formLogo && <img src={formLogo} alt="" />}</StyledFormLogo>
          {isLongTitle ? (
            <StyledFormTitleContainer isLongTitle={isLongTitle}>
              <StyledFormTitle isMobile={isMobile}>{formTitle}</StyledFormTitle>
            </StyledFormTitleContainer>
          ) : (
            <StyledFormTitle isMobile={isMobile}>{formTitle}</StyledFormTitle>
          )}
          {isAuthenticated ? (
            <StyledOrgUserInfo>
              <OrgUserDropdown
                orgName={orgName}
                orgLogo={orgLogo}
                userName={userName}
                logOutRequest={logOutRequest}
                landingPageLink={landingPageLink}
                portalLink={portalLink}
                appVersion={appVersion}
              />
            </StyledOrgUserInfo>
          ) : (
            <StyledOrgUserInfo />
          )}
        </>
      </StyledOrganisationHeader>
    </>
  )
}

export default OrganisationHeader
